/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * PanLuma API
 * Enterprise productivity application API
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type { AgentBudgetConfig } from '../models/agentBudgetConfig';

import type { BudgetConfigRequest } from '../models/budgetConfigRequest';

import type { HTTPValidationError } from '../models/hTTPValidationError';

import type { ModelConfigRequest } from '../models/modelConfigRequest';

import type { TenantBudgetDefaultsRequest } from '../models/tenantBudgetDefaultsRequest';

import type { TenantBudgetDefaultsResponse } from '../models/tenantBudgetDefaultsResponse';

import { customInstance } from '../../../shared/api/axiosInstance';

/**
 * Get model configuration for a agent.
 * @summary Get Model Config
 */
export const getModelConfigApiV1AiAgentsAgentsAgentIdModelConfigGet = (
  agentId: string,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/ai-agents/agents/${agentId}/model-config`,
    method: 'GET',
    signal
  });
};

export const getGetModelConfigApiV1AiAgentsAgentsAgentIdModelConfigGetQueryKey =
  (agentId?: string) => {
    return [`/api/v1/ai-agents/agents/${agentId}/model-config`] as const;
  };

export const getGetModelConfigApiV1AiAgentsAgentsAgentIdModelConfigGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getModelConfigApiV1AiAgentsAgentsAgentIdModelConfigGet>
    >,
    TError = HTTPValidationError
  >(
    agentId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getModelConfigApiV1AiAgentsAgentsAgentIdModelConfigGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetModelConfigApiV1AiAgentsAgentsAgentIdModelConfigGetQueryKey(
        agentId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getModelConfigApiV1AiAgentsAgentsAgentIdModelConfigGet
        >
      >
    > = ({ signal }) =>
      getModelConfigApiV1AiAgentsAgentsAgentIdModelConfigGet(agentId, signal);

    return {
      queryKey,
      queryFn,
      enabled: !!agentId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getModelConfigApiV1AiAgentsAgentsAgentIdModelConfigGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetModelConfigApiV1AiAgentsAgentsAgentIdModelConfigGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getModelConfigApiV1AiAgentsAgentsAgentIdModelConfigGet>
    >
  >;
export type GetModelConfigApiV1AiAgentsAgentsAgentIdModelConfigGetQueryError =
  HTTPValidationError;

export function useGetModelConfigApiV1AiAgentsAgentsAgentIdModelConfigGet<
  TData = Awaited<
    ReturnType<typeof getModelConfigApiV1AiAgentsAgentsAgentIdModelConfigGet>
  >,
  TError = HTTPValidationError
>(
  agentId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getModelConfigApiV1AiAgentsAgentsAgentIdModelConfigGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getModelConfigApiV1AiAgentsAgentsAgentIdModelConfigGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getModelConfigApiV1AiAgentsAgentsAgentIdModelConfigGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetModelConfigApiV1AiAgentsAgentsAgentIdModelConfigGet<
  TData = Awaited<
    ReturnType<typeof getModelConfigApiV1AiAgentsAgentsAgentIdModelConfigGet>
  >,
  TError = HTTPValidationError
>(
  agentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getModelConfigApiV1AiAgentsAgentsAgentIdModelConfigGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getModelConfigApiV1AiAgentsAgentsAgentIdModelConfigGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getModelConfigApiV1AiAgentsAgentsAgentIdModelConfigGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetModelConfigApiV1AiAgentsAgentsAgentIdModelConfigGet<
  TData = Awaited<
    ReturnType<typeof getModelConfigApiV1AiAgentsAgentsAgentIdModelConfigGet>
  >,
  TError = HTTPValidationError
>(
  agentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getModelConfigApiV1AiAgentsAgentsAgentIdModelConfigGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Model Config
 */

export function useGetModelConfigApiV1AiAgentsAgentsAgentIdModelConfigGet<
  TData = Awaited<
    ReturnType<typeof getModelConfigApiV1AiAgentsAgentsAgentIdModelConfigGet>
  >,
  TError = HTTPValidationError
>(
  agentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getModelConfigApiV1AiAgentsAgentsAgentIdModelConfigGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetModelConfigApiV1AiAgentsAgentsAgentIdModelConfigGetQueryOptions(
      agentId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Update model configuration for a agent.

Model selection / system-prompt override is an agent-config write, so it
requires editor or owner relation on the agent (viewers may only read).
 * @summary Update Model Config
 */
export const updateModelConfigApiV1AiAgentsAgentsAgentIdModelConfigPut = (
  agentId: string,
  modelConfigRequest: ModelConfigRequest
) => {
  return customInstance<unknown>({
    url: `/api/v1/ai-agents/agents/${agentId}/model-config`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: modelConfigRequest
  });
};

export const getUpdateModelConfigApiV1AiAgentsAgentsAgentIdModelConfigPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateModelConfigApiV1AiAgentsAgentsAgentIdModelConfigPut
        >
      >,
      TError,
      { agentId: string; data: ModelConfigRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updateModelConfigApiV1AiAgentsAgentsAgentIdModelConfigPut
      >
    >,
    TError,
    { agentId: string; data: ModelConfigRequest },
    TContext
  > => {
    const mutationKey = [
      'updateModelConfigApiV1AiAgentsAgentsAgentIdModelConfigPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateModelConfigApiV1AiAgentsAgentsAgentIdModelConfigPut
        >
      >,
      { agentId: string; data: ModelConfigRequest }
    > = (props) => {
      const { agentId, data } = props ?? {};

      return updateModelConfigApiV1AiAgentsAgentsAgentIdModelConfigPut(
        agentId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateModelConfigApiV1AiAgentsAgentsAgentIdModelConfigPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updateModelConfigApiV1AiAgentsAgentsAgentIdModelConfigPut
      >
    >
  >;
export type UpdateModelConfigApiV1AiAgentsAgentsAgentIdModelConfigPutMutationBody =
  ModelConfigRequest;
export type UpdateModelConfigApiV1AiAgentsAgentsAgentIdModelConfigPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Model Config
 */
export const useUpdateModelConfigApiV1AiAgentsAgentsAgentIdModelConfigPut = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateModelConfigApiV1AiAgentsAgentsAgentIdModelConfigPut
        >
      >,
      TError,
      { agentId: string; data: ModelConfigRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof updateModelConfigApiV1AiAgentsAgentsAgentIdModelConfigPut>
  >,
  TError,
  { agentId: string; data: ModelConfigRequest },
  TContext
> => {
  const mutationOptions =
    getUpdateModelConfigApiV1AiAgentsAgentsAgentIdModelConfigPutMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Get model categories available to this tenant for agent configuration.

Returns categories with resolved model and reasoning info.
 * @summary Get Available Model Categories
 */
export const getAvailableModelCategoriesApiV1AiAgentsAvailableModelCategoriesGet =
  (signal?: AbortSignal) => {
    return customInstance<unknown>({
      url: `/api/v1/ai-agents/available-model-categories`,
      method: 'GET',
      signal
    });
  };

export const getGetAvailableModelCategoriesApiV1AiAgentsAvailableModelCategoriesGetQueryKey =
  () => {
    return [`/api/v1/ai-agents/available-model-categories`] as const;
  };

export const getGetAvailableModelCategoriesApiV1AiAgentsAvailableModelCategoriesGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getAvailableModelCategoriesApiV1AiAgentsAvailableModelCategoriesGet
      >
    >,
    TError = unknown
  >(options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getAvailableModelCategoriesApiV1AiAgentsAvailableModelCategoriesGet
          >
        >,
        TError,
        TData
      >
    >;
  }) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetAvailableModelCategoriesApiV1AiAgentsAvailableModelCategoriesGetQueryKey();

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getAvailableModelCategoriesApiV1AiAgentsAvailableModelCategoriesGet
        >
      >
    > = ({ signal }) =>
      getAvailableModelCategoriesApiV1AiAgentsAvailableModelCategoriesGet(
        signal
      );

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getAvailableModelCategoriesApiV1AiAgentsAvailableModelCategoriesGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetAvailableModelCategoriesApiV1AiAgentsAvailableModelCategoriesGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getAvailableModelCategoriesApiV1AiAgentsAvailableModelCategoriesGet
      >
    >
  >;
export type GetAvailableModelCategoriesApiV1AiAgentsAvailableModelCategoriesGetQueryError =
  unknown;

export function useGetAvailableModelCategoriesApiV1AiAgentsAvailableModelCategoriesGet<
  TData = Awaited<
    ReturnType<
      typeof getAvailableModelCategoriesApiV1AiAgentsAvailableModelCategoriesGet
    >
  >,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getAvailableModelCategoriesApiV1AiAgentsAvailableModelCategoriesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getAvailableModelCategoriesApiV1AiAgentsAvailableModelCategoriesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getAvailableModelCategoriesApiV1AiAgentsAvailableModelCategoriesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetAvailableModelCategoriesApiV1AiAgentsAvailableModelCategoriesGet<
  TData = Awaited<
    ReturnType<
      typeof getAvailableModelCategoriesApiV1AiAgentsAvailableModelCategoriesGet
    >
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getAvailableModelCategoriesApiV1AiAgentsAvailableModelCategoriesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getAvailableModelCategoriesApiV1AiAgentsAvailableModelCategoriesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getAvailableModelCategoriesApiV1AiAgentsAvailableModelCategoriesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetAvailableModelCategoriesApiV1AiAgentsAvailableModelCategoriesGet<
  TData = Awaited<
    ReturnType<
      typeof getAvailableModelCategoriesApiV1AiAgentsAvailableModelCategoriesGet
    >
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getAvailableModelCategoriesApiV1AiAgentsAvailableModelCategoriesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Available Model Categories
 */

export function useGetAvailableModelCategoriesApiV1AiAgentsAvailableModelCategoriesGet<
  TData = Awaited<
    ReturnType<
      typeof getAvailableModelCategoriesApiV1AiAgentsAvailableModelCategoriesGet
    >
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getAvailableModelCategoriesApiV1AiAgentsAvailableModelCategoriesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetAvailableModelCategoriesApiV1AiAgentsAvailableModelCategoriesGetQueryOptions(
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get processing statistics for an agent — 24h token usage + estimated cost.

The Processing tab's budget section fetches its own caps/status via
``GET /budget-config``; this endpoint stays the lean usage summary.
 * @summary Get Processing Stats
 */
export const getProcessingStatsApiV1AiAgentsAgentsAgentIdProcessingStatsGet = (
  agentId: string,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/ai-agents/agents/${agentId}/processing-stats`,
    method: 'GET',
    signal
  });
};

export const getGetProcessingStatsApiV1AiAgentsAgentsAgentIdProcessingStatsGetQueryKey =
  (agentId?: string) => {
    return [`/api/v1/ai-agents/agents/${agentId}/processing-stats`] as const;
  };

export const getGetProcessingStatsApiV1AiAgentsAgentsAgentIdProcessingStatsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getProcessingStatsApiV1AiAgentsAgentsAgentIdProcessingStatsGet
      >
    >,
    TError = HTTPValidationError
  >(
    agentId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getProcessingStatsApiV1AiAgentsAgentsAgentIdProcessingStatsGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetProcessingStatsApiV1AiAgentsAgentsAgentIdProcessingStatsGetQueryKey(
        agentId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getProcessingStatsApiV1AiAgentsAgentsAgentIdProcessingStatsGet
        >
      >
    > = ({ signal }) =>
      getProcessingStatsApiV1AiAgentsAgentsAgentIdProcessingStatsGet(
        agentId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!agentId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getProcessingStatsApiV1AiAgentsAgentsAgentIdProcessingStatsGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetProcessingStatsApiV1AiAgentsAgentsAgentIdProcessingStatsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getProcessingStatsApiV1AiAgentsAgentsAgentIdProcessingStatsGet
      >
    >
  >;
export type GetProcessingStatsApiV1AiAgentsAgentsAgentIdProcessingStatsGetQueryError =
  HTTPValidationError;

export function useGetProcessingStatsApiV1AiAgentsAgentsAgentIdProcessingStatsGet<
  TData = Awaited<
    ReturnType<
      typeof getProcessingStatsApiV1AiAgentsAgentsAgentIdProcessingStatsGet
    >
  >,
  TError = HTTPValidationError
>(
  agentId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getProcessingStatsApiV1AiAgentsAgentsAgentIdProcessingStatsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getProcessingStatsApiV1AiAgentsAgentsAgentIdProcessingStatsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getProcessingStatsApiV1AiAgentsAgentsAgentIdProcessingStatsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetProcessingStatsApiV1AiAgentsAgentsAgentIdProcessingStatsGet<
  TData = Awaited<
    ReturnType<
      typeof getProcessingStatsApiV1AiAgentsAgentsAgentIdProcessingStatsGet
    >
  >,
  TError = HTTPValidationError
>(
  agentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getProcessingStatsApiV1AiAgentsAgentsAgentIdProcessingStatsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getProcessingStatsApiV1AiAgentsAgentsAgentIdProcessingStatsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getProcessingStatsApiV1AiAgentsAgentsAgentIdProcessingStatsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetProcessingStatsApiV1AiAgentsAgentsAgentIdProcessingStatsGet<
  TData = Awaited<
    ReturnType<
      typeof getProcessingStatsApiV1AiAgentsAgentsAgentIdProcessingStatsGet
    >
  >,
  TError = HTTPValidationError
>(
  agentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getProcessingStatsApiV1AiAgentsAgentsAgentIdProcessingStatsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Processing Stats
 */

export function useGetProcessingStatsApiV1AiAgentsAgentsAgentIdProcessingStatsGet<
  TData = Awaited<
    ReturnType<
      typeof getProcessingStatsApiV1AiAgentsAgentsAgentIdProcessingStatsGet
    >
  >,
  TError = HTTPValidationError
>(
  agentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getProcessingStatsApiV1AiAgentsAgentsAgentIdProcessingStatsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetProcessingStatsApiV1AiAgentsAgentsAgentIdProcessingStatsGetQueryOptions(
      agentId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get the agent's spend-cap config: effective caps, per-field overrides,
24h usage, status, and pause state.
 * @summary Get Budget Config
 */
export const getBudgetConfigApiV1AiAgentsAgentsAgentIdBudgetConfigGet = (
  agentId: string,
  signal?: AbortSignal
) => {
  return customInstance<AgentBudgetConfig>({
    url: `/api/v1/ai-agents/agents/${agentId}/budget-config`,
    method: 'GET',
    signal
  });
};

export const getGetBudgetConfigApiV1AiAgentsAgentsAgentIdBudgetConfigGetQueryKey =
  (agentId?: string) => {
    return [`/api/v1/ai-agents/agents/${agentId}/budget-config`] as const;
  };

export const getGetBudgetConfigApiV1AiAgentsAgentsAgentIdBudgetConfigGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getBudgetConfigApiV1AiAgentsAgentsAgentIdBudgetConfigGet
      >
    >,
    TError = HTTPValidationError
  >(
    agentId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getBudgetConfigApiV1AiAgentsAgentsAgentIdBudgetConfigGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetBudgetConfigApiV1AiAgentsAgentsAgentIdBudgetConfigGetQueryKey(
        agentId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getBudgetConfigApiV1AiAgentsAgentsAgentIdBudgetConfigGet
        >
      >
    > = ({ signal }) =>
      getBudgetConfigApiV1AiAgentsAgentsAgentIdBudgetConfigGet(agentId, signal);

    return {
      queryKey,
      queryFn,
      enabled: !!agentId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getBudgetConfigApiV1AiAgentsAgentsAgentIdBudgetConfigGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetBudgetConfigApiV1AiAgentsAgentsAgentIdBudgetConfigGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getBudgetConfigApiV1AiAgentsAgentsAgentIdBudgetConfigGet
      >
    >
  >;
export type GetBudgetConfigApiV1AiAgentsAgentsAgentIdBudgetConfigGetQueryError =
  HTTPValidationError;

export function useGetBudgetConfigApiV1AiAgentsAgentsAgentIdBudgetConfigGet<
  TData = Awaited<
    ReturnType<typeof getBudgetConfigApiV1AiAgentsAgentsAgentIdBudgetConfigGet>
  >,
  TError = HTTPValidationError
>(
  agentId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getBudgetConfigApiV1AiAgentsAgentsAgentIdBudgetConfigGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getBudgetConfigApiV1AiAgentsAgentsAgentIdBudgetConfigGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getBudgetConfigApiV1AiAgentsAgentsAgentIdBudgetConfigGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetBudgetConfigApiV1AiAgentsAgentsAgentIdBudgetConfigGet<
  TData = Awaited<
    ReturnType<typeof getBudgetConfigApiV1AiAgentsAgentsAgentIdBudgetConfigGet>
  >,
  TError = HTTPValidationError
>(
  agentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getBudgetConfigApiV1AiAgentsAgentsAgentIdBudgetConfigGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getBudgetConfigApiV1AiAgentsAgentsAgentIdBudgetConfigGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getBudgetConfigApiV1AiAgentsAgentsAgentIdBudgetConfigGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetBudgetConfigApiV1AiAgentsAgentsAgentIdBudgetConfigGet<
  TData = Awaited<
    ReturnType<typeof getBudgetConfigApiV1AiAgentsAgentsAgentIdBudgetConfigGet>
  >,
  TError = HTTPValidationError
>(
  agentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getBudgetConfigApiV1AiAgentsAgentsAgentIdBudgetConfigGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Budget Config
 */

export function useGetBudgetConfigApiV1AiAgentsAgentsAgentIdBudgetConfigGet<
  TData = Awaited<
    ReturnType<typeof getBudgetConfigApiV1AiAgentsAgentsAgentIdBudgetConfigGet>
  >,
  TError = HTTPValidationError
>(
  agentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getBudgetConfigApiV1AiAgentsAgentsAgentIdBudgetConfigGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetBudgetConfigApiV1AiAgentsAgentsAgentIdBudgetConfigGetQueryOptions(
      agentId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Update the agent's spend-cap config (per-agent overrides + pause switch).

A field passed as a value sets an agent-level override; a field named in
``clear_fields`` removes the override so it re-inherits tenant/platform.

Spend caps + the pause switch are financial/availability controls, so this
write requires editor or owner relation on the agent (viewers may only read).
 * @summary Update Budget Config
 */
export const updateBudgetConfigApiV1AiAgentsAgentsAgentIdBudgetConfigPut = (
  agentId: string,
  budgetConfigRequest: BudgetConfigRequest
) => {
  return customInstance<AgentBudgetConfig>({
    url: `/api/v1/ai-agents/agents/${agentId}/budget-config`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: budgetConfigRequest
  });
};

export const getUpdateBudgetConfigApiV1AiAgentsAgentsAgentIdBudgetConfigPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateBudgetConfigApiV1AiAgentsAgentsAgentIdBudgetConfigPut
        >
      >,
      TError,
      { agentId: string; data: BudgetConfigRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updateBudgetConfigApiV1AiAgentsAgentsAgentIdBudgetConfigPut
      >
    >,
    TError,
    { agentId: string; data: BudgetConfigRequest },
    TContext
  > => {
    const mutationKey = [
      'updateBudgetConfigApiV1AiAgentsAgentsAgentIdBudgetConfigPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateBudgetConfigApiV1AiAgentsAgentsAgentIdBudgetConfigPut
        >
      >,
      { agentId: string; data: BudgetConfigRequest }
    > = (props) => {
      const { agentId, data } = props ?? {};

      return updateBudgetConfigApiV1AiAgentsAgentsAgentIdBudgetConfigPut(
        agentId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateBudgetConfigApiV1AiAgentsAgentsAgentIdBudgetConfigPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updateBudgetConfigApiV1AiAgentsAgentsAgentIdBudgetConfigPut
      >
    >
  >;
export type UpdateBudgetConfigApiV1AiAgentsAgentsAgentIdBudgetConfigPutMutationBody =
  BudgetConfigRequest;
export type UpdateBudgetConfigApiV1AiAgentsAgentsAgentIdBudgetConfigPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Budget Config
 */
export const useUpdateBudgetConfigApiV1AiAgentsAgentsAgentIdBudgetConfigPut = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateBudgetConfigApiV1AiAgentsAgentsAgentIdBudgetConfigPut
        >
      >,
      TError,
      { agentId: string; data: BudgetConfigRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<
      typeof updateBudgetConfigApiV1AiAgentsAgentsAgentIdBudgetConfigPut
    >
  >,
  TError,
  { agentId: string; data: BudgetConfigRequest },
  TContext
> => {
  const mutationOptions =
    getUpdateBudgetConfigApiV1AiAgentsAgentsAgentIdBudgetConfigPutMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Get the tenant's agent-budget defaults (and the platform fallback).
 * @summary Get Tenant Budget Defaults
 */
export const getTenantBudgetDefaultsApiV1AiAgentsBudgetDefaultsGet = (
  signal?: AbortSignal
) => {
  return customInstance<TenantBudgetDefaultsResponse>({
    url: `/api/v1/ai-agents/budget-defaults`,
    method: 'GET',
    signal
  });
};

export const getGetTenantBudgetDefaultsApiV1AiAgentsBudgetDefaultsGetQueryKey =
  () => {
    return [`/api/v1/ai-agents/budget-defaults`] as const;
  };

export const getGetTenantBudgetDefaultsApiV1AiAgentsBudgetDefaultsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getTenantBudgetDefaultsApiV1AiAgentsBudgetDefaultsGet>
    >,
    TError = unknown
  >(options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getTenantBudgetDefaultsApiV1AiAgentsBudgetDefaultsGet
          >
        >,
        TError,
        TData
      >
    >;
  }) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetTenantBudgetDefaultsApiV1AiAgentsBudgetDefaultsGetQueryKey();

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof getTenantBudgetDefaultsApiV1AiAgentsBudgetDefaultsGet>
      >
    > = ({ signal }) =>
      getTenantBudgetDefaultsApiV1AiAgentsBudgetDefaultsGet(signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<typeof getTenantBudgetDefaultsApiV1AiAgentsBudgetDefaultsGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetTenantBudgetDefaultsApiV1AiAgentsBudgetDefaultsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getTenantBudgetDefaultsApiV1AiAgentsBudgetDefaultsGet>
    >
  >;
export type GetTenantBudgetDefaultsApiV1AiAgentsBudgetDefaultsGetQueryError =
  unknown;

export function useGetTenantBudgetDefaultsApiV1AiAgentsBudgetDefaultsGet<
  TData = Awaited<
    ReturnType<typeof getTenantBudgetDefaultsApiV1AiAgentsBudgetDefaultsGet>
  >,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getTenantBudgetDefaultsApiV1AiAgentsBudgetDefaultsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getTenantBudgetDefaultsApiV1AiAgentsBudgetDefaultsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getTenantBudgetDefaultsApiV1AiAgentsBudgetDefaultsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetTenantBudgetDefaultsApiV1AiAgentsBudgetDefaultsGet<
  TData = Awaited<
    ReturnType<typeof getTenantBudgetDefaultsApiV1AiAgentsBudgetDefaultsGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getTenantBudgetDefaultsApiV1AiAgentsBudgetDefaultsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getTenantBudgetDefaultsApiV1AiAgentsBudgetDefaultsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getTenantBudgetDefaultsApiV1AiAgentsBudgetDefaultsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTenantBudgetDefaultsApiV1AiAgentsBudgetDefaultsGet<
  TData = Awaited<
    ReturnType<typeof getTenantBudgetDefaultsApiV1AiAgentsBudgetDefaultsGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getTenantBudgetDefaultsApiV1AiAgentsBudgetDefaultsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Tenant Budget Defaults
 */

export function useGetTenantBudgetDefaultsApiV1AiAgentsBudgetDefaultsGet<
  TData = Awaited<
    ReturnType<typeof getTenantBudgetDefaultsApiV1AiAgentsBudgetDefaultsGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getTenantBudgetDefaultsApiV1AiAgentsBudgetDefaultsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetTenantBudgetDefaultsApiV1AiAgentsBudgetDefaultsGetQueryOptions(
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Update the tenant's agent-budget defaults (admin only).
 * @summary Update Tenant Budget Defaults
 */
export const updateTenantBudgetDefaultsApiV1AiAgentsBudgetDefaultsPut = (
  tenantBudgetDefaultsRequest: TenantBudgetDefaultsRequest
) => {
  return customInstance<TenantBudgetDefaultsResponse>({
    url: `/api/v1/ai-agents/budget-defaults`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: tenantBudgetDefaultsRequest
  });
};

export const getUpdateTenantBudgetDefaultsApiV1AiAgentsBudgetDefaultsPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateTenantBudgetDefaultsApiV1AiAgentsBudgetDefaultsPut
        >
      >,
      TError,
      { data: TenantBudgetDefaultsRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updateTenantBudgetDefaultsApiV1AiAgentsBudgetDefaultsPut
      >
    >,
    TError,
    { data: TenantBudgetDefaultsRequest },
    TContext
  > => {
    const mutationKey = [
      'updateTenantBudgetDefaultsApiV1AiAgentsBudgetDefaultsPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateTenantBudgetDefaultsApiV1AiAgentsBudgetDefaultsPut
        >
      >,
      { data: TenantBudgetDefaultsRequest }
    > = (props) => {
      const { data } = props ?? {};

      return updateTenantBudgetDefaultsApiV1AiAgentsBudgetDefaultsPut(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateTenantBudgetDefaultsApiV1AiAgentsBudgetDefaultsPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updateTenantBudgetDefaultsApiV1AiAgentsBudgetDefaultsPut
      >
    >
  >;
export type UpdateTenantBudgetDefaultsApiV1AiAgentsBudgetDefaultsPutMutationBody =
  TenantBudgetDefaultsRequest;
export type UpdateTenantBudgetDefaultsApiV1AiAgentsBudgetDefaultsPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Tenant Budget Defaults
 */
export const useUpdateTenantBudgetDefaultsApiV1AiAgentsBudgetDefaultsPut = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateTenantBudgetDefaultsApiV1AiAgentsBudgetDefaultsPut
        >
      >,
      TError,
      { data: TenantBudgetDefaultsRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof updateTenantBudgetDefaultsApiV1AiAgentsBudgetDefaultsPut>
  >,
  TError,
  { data: TenantBudgetDefaultsRequest },
  TContext
> => {
  const mutationOptions =
    getUpdateTenantBudgetDefaultsApiV1AiAgentsBudgetDefaultsPutMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
